import { AppBox } from "../../../../../commons/components";
import { ManageFootballSubTeam } from "../../../../../commons/models/football/admin/manage-football-sub-team";

interface SubTeamTerminateProps {
  subTeam: ManageFootballSubTeam;
}
export default function SubTeamTerminate({ subTeam }: SubTeamTerminateProps) {
  return (
    <AppBox displayBlock>
      Once you terminate sub-team <strong>“{subTeam.name}”</strong>, the team will no longer be able to participate in any
      tournament.
    </AppBox>
  );
}
